import React from 'react'
import '../App.css'

export default function Intro() {
    return (
        <>
            <div className='w-screen my-16 flex items-center justify-between'>
                <div className="left lg:w-1/2 my-color pb-10">
                    <h1 className='text-white lg:text-5xl text-3xl w-11/12 font-bold px-2 pt-10 pb-4'>Welcome to <span className='text-orange-400'>Shubham Gupta's </span>Coding Cheatsheet</h1>
                    <p className='text-white w-9/12 px-2'>Computer programming is the process of performing a particular computation (or more generally, accomplishing a specific computing result), usually by designing/building an executable computer program. Programming involves tasks such as analysis, generating algorithms, profiling algorithms' accuracy and resource consumption, and the implementation of algorithms (usually in a chosen programming language, commonly referred to as coding).</p>
                </div>
                <div className="right lg:w-1/2 lg:h-96 bg-cyan-300"></div>
            </div>
            <div className="mx-auto mt-10  w-4/5 flex flex-col items-center justify-center py-6">
                <h1 className='text-4xl p-4 uppercase text-center'>What And Why are Coding Cheatsheets?</h1>
                <p className=' w-3/5 text-center'>Coding Cheatsheets Help in a lot of ways.Like sometime you just forgot your Snippets so they will help you remember what war you snippet and what was its syntax. Here are some snippets in vs code which have been created by myself. there are also a lot of components with syntax which can be used for free it contains html and css and js if used of the component </p>
                <span className='p-0.5 gradient-span w-1/2 mt-16 mb-4'></span>
                <div className="cardDiv flex-wrap flex items-center justify-center w-screen">
                    <div className="card1 w-64 h-64 flex items-center justify-around flex-col">
                        <i className="fa-solid fa-keyboard text-orange-400 text-9xl"></i>
                        <h1 className='text-2xl text-center px-2 font-semibold capitalize'>Less Typing with components</h1>
                        <span className='w-1/2 p-0.5 bg-orange-400'></span>
                    </div>
                    <div className="card1 w-64 m-10 h-64 flex items-center justify-around flex-col">
                        <i className="fa-solid fa-gauge-high text-green-400 text-9xl"></i>
                        <h1 className='text-2xl text-center px-2 font-semibold capitalize'>have a Faster Coding with snippets</h1>
                        <span className='w-1/2 p-0.5 bg-green-400'></span>
                    </div>
                    <div className="card1 w-64 h-64 flex items-center justify-around flex-col">
                        <i className="fa-solid fa-code text-sky-400 text-9xl"></i>
                        <h1 className='text-2xl text-center px-2 font-semibold capitalize'>No need to remember syntax</h1>
                        <span className='w-1/2 p-0.5 bg-sky-400'></span>
                    </div>
                </div>
            </div>
        </>
    )
}
